__turbopack_context__.v({
  "videoPlayer": "index-module__PkaBIa__videoPlayer",
});
